import Vue from 'vue'
import Banner from './banner'
import LocalStorage from './localStorage'
import Modal from './modal'
import Fileviewer from './fileviewer'
import Files from './files'

Vue.mixin(Banner)
Vue.mixin(LocalStorage)
Vue.mixin(Modal)
Vue.mixin(Fileviewer)
Vue.mixin(Files)